import React, { useEffect } from 'react'
import styled from 'styled-components'
import Modal, { IFModalProps } from '@app.components/Modal/Modal'
import CloseOutlined from 'svgIcons/CloseOutlined'
import { DutyList } from './components/DutyList'
import TableActions from './components/TableActions'
import { useDutyModalStore } from './store/dutyModal'

interface TProps extends IFModalProps {
  onClose: () => void
}

const DutyModal: React.FC<TProps> = ({ open, onClose }) => {
  const setCloseModal = useDutyModalStore((store) => store.setCloseModal)
  const resetVariables = useDutyModalStore((store) => store.resetVariables)
  setCloseModal(onClose)

  useEffect(() => {
    return () => {
      resetVariables()
    }
  }, [])

  return (
    <Modal open={open} onClose={onClose}>
      <StyledWrapper>
        <div className="modal-wrapper">
          <div className="close-btn" onClick={onClose}>
            <CloseOutlined />
          </div>
          <h1 className="modal-title">공고 선택하기</h1>
          <TableActions />
          <DutyList />
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default DutyModal

const StyledWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .modal-wrapper {
    position: relative;
    border-radius: 20px;
    background-color: white;
    padding: 30px;
    width: 920px;
    .close-btn {
      z-index: 2;
      cursor: pointer;
      position: absolute;
      top: 30px;
      color: #999999;
      right: 30px;

      svg {
        width: 30px;
        height: 30px;
      }
    }
    .modal-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 600;
      margin-top: 0;
      margin-bottom: 36px;
    }
  }
`
